import { MutationTree } from 'vuex';
import { OriginatorsState } from './types';

export const mutations: MutationTree<OriginatorsState> = {
    pushOriginators:(state, data) => {
        state.originators = state.originators.concat(data)
    },
    setOriginators:(state, data) => {
        state.originators = data
    },
    setOriginatorItem:(state, data) => {
        state.originatorItem = data
    },
};
